import React, { useState } from "react";
import Tags from "./Tags";
import { Row, Col, Card, Badge } from "react-bootstrap";
import CallCut from "assets/svgs/call_cut.js";
import CallIcon from "assets/svgs/table_call";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { useCall } from "./store";
import FeedbackForm from "../feedback_form/FeedbackForm";
import Reschedule from "./Reschedule";
import moment from "moment";
import PrescriptionFeedbackForm from "../feedback_form/PrescriptionFeedback";
import { currentUser, getCurrentUserRole } from "modules/utilities/utility";

function TableItem({
                     item,
                     rounded,
                     setState,
                     setDocData,
                     assignedOrder,
                     setActiveCaseId,
                   }) {
  const [booking, setBooking] = useState();
  const [data, setData] = useState();
  const { setToaster } = useToast();
  const { call } = useCall();
  const [callIcon, setCallIcon] = useState(<CallIcon />);
  const [isHovered, setIsHovered] = useState(false);
  const selectionAccess = ["lead_agent"];

  const formSelection = (week, activeOrder) => {
    switch (week) {
      case "Prescription Call":
      case "Week 1":
        return (
            <PrescriptionFeedbackForm
                list={true}
                week={activeOrder.tag}
                id={activeOrder._id}
                bookingId={activeOrder.booking_reference_id}
            />
        );

      default:
        return (
            <FeedbackForm
                setBooking={setBooking}
                data={activeOrder}
                week={activeOrder?.tag}
                id={activeOrder?._id}
                bookingId={activeOrder.booking_reference_id}
                customerId={item.case_id}
                setData={setData}
                list={true}
            />
        );
    }
  };

  // Format time for better readability
  const formatTime = (dateTime) => {
    return moment(dateTime).format("DD MMM YYYY, h:mm A");
  };

  // Handle call action
  const handleCall = () => {
    setCallIcon(<CallCut />);
    call(item.case_id, {}, item?._id || null, item?.phone_number, setToaster, true);
  };

  // Handle customer selection
  const handleCustomerSelect = () => {
    setDocData(null);
    setState(item);
    setActiveCaseId(item.case_id);
  };

  return (
      <Card
          className={`mb-2 border-left-accent ${rounded ? "rounded" : ""} ${isHovered ? "shadow-sm" : ""}`}
          style={{
            transition: "all 0.2s ease-in-out",
            borderLeft: "4px solid #007bff"
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
      >
        <Card.Body className="p-0">
          <Row className="g-0">
            {/* Customer Information */}
            <Col
                md={4}
                className="cursor-pointer p-3"
                style={{
                  background: isHovered ? "#f8f9fa" : "#f2f2f2",
                  transition: "background 0.2s ease-in-out",
                  borderRight: "1px solid #e9ecef"
                }}
                onClick={handleCustomerSelect}
            >
              <div className="d-flex flex-column h-100 justify-content-between">
                <div>
                  <h5 className="text-primary mb-2 fw-bold text-capitalize text-break">
                    {item?.first_name} {item?.last_name}
                    {item?.count && (
                        <Badge bg="secondary" className="ms-2 rounded-pill">
                          {item.count}
                        </Badge>
                    )}
                  </h5>
                </div>

                <div className="mt-2">
                  <div className="d-flex align-items-center">
                    <i className="far fa-calendar-alt me-2 text-secondary"></i>
                    <span className="text-secondary fw-medium">
                    {formatTime(item?.reminder_date)}
                  </span>
                  </div>

                  {item?.phone_number && (
                      <div className="mt-1 text-muted small">
                        <i className="fas fa-phone-alt me-2"></i>
                        {item.phone_number}
                      </div>
                  )}
                </div>
              </div>
            </Col>

            {/* Tags Section */}
            <Col md={5} className="p-3" style={{ background: "#fff" }}>
              <Tags item={item} />
            </Col>

            {/* Actions Section */}
            {!assignedOrder && getCurrentUserRole() !== "medical" && (
                <Col
                    md={3}
                    className="d-flex justify-content-around align-items-center p-3"
                    style={{
                      background: "#fff",
                      borderLeft: "1px solid #e9ecef"
                    }}
                >
                  <div className="d-flex flex-column gap-2 align-items-center w-100">
                    <button
                        className="border-0 bg-transparent"
                        onClick={handleCall}
                    >
                      {callIcon}
                    </button>

                    {!selectionAccess.includes(currentUser) && (
                        <div>
                          {formSelection(item.tag, item)}
                        </div>
                    )}

                    {item.order && (
                        <div>
                          <Reschedule
                              list={true}
                              item={item}
                              dueDate={item.reminder_date}
                              id={item._id}
                          />
                        </div>
                    )}
                  </div>
                </Col>
            )}
          </Row>
        </Card.Body>
      </Card>
  );
}

export default TableItem;